<template>
  <div>
    <CRow class="form-group">
      <CCol :sm="labelWidth">
        <!-- <label for="month-year-picker" class="col-form-label">Choose a month and year:</label> -->
        
          <label v-if="label" class="col-form-label">
            {{label}}
          </label>
      </CCol>
      <CCol :sm="inputWidth">
        <CRow>
          <CCol sm="6">
            <select v-model="selectedMonth" id="month" name="month" :class="inputMonthClass" @change="emitMonth">
              <option value="">--Select-Month--</option>
              <option value="01">January</option>
              <option value="02">February</option>
              <option value="03">March</option>
              <option value="04">April</option>
              <option value="05">May</option>
              <option value="06">June</option>
              <option value="07">July</option>
              <option value="08">August</option>
              <option value="09">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </CCol>
          <CCol sm="6">
            <select v-model="selectedYear" id="year" name="year" :class="inputYearClass" @change="emitMonth">
              <option v-for="(option, index) in selecteYearOption" :key="index" :value="option.value">
                {{ option.label }}
              </option>
            </select>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "CCmonth",
  props: {
    startYear: {
      type: Number,
      default: 2023,
    },
    endYear: {
      type: Number
    },
    required: {
      type: Boolean,
      default: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Choose a month and year:",
    },
  },
  data() {
    return {
      selectedMonth: "",
      selectedYear: "",
      selecteYearOption: [],
    };
  },
  mounted() {
    this.initYearOption()
    this.updateSelectedValues(this.value)
  },
  watch: {
    value(newValue) {
      this.updateSelectedValues(newValue)
    },
  },
  computed: {
    inputWidth() {
      return this.horizontal ? "9" : "12";
    },
    labelWidth() {
      return this.horizontal ? "3" : "12";
    },
    inputMonthClass() {
      return this.required
        ? this.selectedMonth
          ? "form-control is-valid"
          : "form-control is-invalid"
        : "form-control";
    },
    inputYearClass() {
      return this.required
        ? this.selectedYear
          ? "form-control is-valid"
          : "form-control is-invalid"
        : "form-control";
    },
  },
  methods: {
    updateSelectedValues(value) {
      const [year, month] = value.split("-")
      this.selectedYear = year || ""
      this.selectedMonth = month || ""
    },
    initYearOption() {
      this.selecteYearOption.push({
        value: "",
        label: "--Select-Year--",
      });
      // const endYear = new Date().getFullYear()
      const endYear = this.endYear || new Date().getFullYear()
      for (let year = endYear; year >= this.startYear; year--) {
        this.selecteYearOption.push({
          value: String(year),
          label: year,
        });
      }
    },
    emitMonth() {
      const month = this.selectedYear && this.selectedMonth ? `${this.selectedYear}-${this.selectedMonth}` : "";
      this.$emit("input", month); // Emit the new value to parent
    },
  },
};
</script>